import { Box, Grid, Paper, styled, useTheme } from "@mui/material";
import { FC, PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom";
import { StyledButton } from "../../components/StyledButton";
import SetLinks from "../../components/layout/SetLinks";
import { DefaultProjectCreateLink } from "../../contexts/layouts/LinkContext";

const AdministrationPanelHeader = styled(Box) (({theme}) => ({
    width: "100%",
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.light
}));


interface IAdministrationPanelRowProps {
    label?: string,
    route?: string,
    actionText?: string
}
const AdministrationPanelRow:FC<IAdministrationPanelRowProps> = ({
    label,
    route,
    actionText
}) => {
    const navigate = useNavigate();
    const theme = useTheme();

    return (
        <Grid
            sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(1),
                height: 30
            }}
        >
            {label ? <Grid>{label}</Grid> : undefined}
            {route ? 
                <StyledButton
                    sx={{
                        height: "90%"
                    }}
                    onClick={() => navigate(route)}
                >
                    {actionText ? actionText : 'Edit'}
                </StyledButton>
                : undefined
            }
        </Grid>
    );
}

interface IAdministrationPanelProps extends PropsWithChildren {
    headerText?: string
}
const AdministrationPanel:FC<IAdministrationPanelProps> = ({
    headerText,
    children
}) => {
    return (
        <Paper
            sx={{
                width: "23%",
                minWidth: 300,
                overflow: "hidden"
            }}
        >
            <AdministrationPanelHeader>{headerText}</AdministrationPanelHeader>
            {children}
        </Paper>
    );
}

const Administration:FC = () => {
    const theme = useTheme();

    return (
        <>
            <SetLinks 
                createProjectLink={DefaultProjectCreateLink} 
                stageLinkEnabled={false} 
                lotLinkEnabled={false}
            />
            <Grid
                container
                gap={theme.spacing(2)}
            >
                <AdministrationPanel 
                    headerText="Agents"
                >
                    <AdministrationPanelRow
                        label="Agents"
                        route="/admin/agents"
                    />
                    <AdministrationPanelRow
                        label="Agent Locations"
                        route="/admin/agent-locations"
                    />
                    <AdministrationPanelRow
                        label="Agent Personnel"
                        route="/admin/agent-personnel"
                    />
                    <AdministrationPanelRow
                        label="Agent Projects"
                        route="/admin/agent-projects"
                    />
                </AdministrationPanel>
                <AdministrationPanel 
                    headerText="Tenants"
                >
                    <AdministrationPanelRow
                        label="Tenants"
                        route="/admin/tenants"
                    />
                    <AdministrationPanelRow />
                    <AdministrationPanelRow />
                    <AdministrationPanelRow />
                </AdministrationPanel>
                <AdministrationPanel 
                    headerText="Lots"
                >
                    <AdministrationPanelRow
                        label="Lot Properties"
                        route="/admin/lot-properties"
                    />
                    <AdministrationPanelRow />
                    <AdministrationPanelRow />
                    <AdministrationPanelRow />
                </AdministrationPanel>
                <AdministrationPanel 
                    headerText="Stages"
                >
                    <AdministrationPanelRow
                        label="Precincts"
                        route="/admin/stage-precincts"
                    />
                    <AdministrationPanelRow />
                    <AdministrationPanelRow />
                    <AdministrationPanelRow />
                </AdministrationPanel>
                <AdministrationPanel 
                    headerText="Attachments"
                >
                    <AdministrationPanelRow
                        label="Attachment Types"
                        route="/admin/attachment-types"
                    />
                    <AdministrationPanelRow />
                    <AdministrationPanelRow />
                    <AdministrationPanelRow />
                </AdministrationPanel>
                <AdministrationPanel 
                    headerText="Legal Users"
                >
                    <AdministrationPanelRow
                        label="Project Permissions"
                        route="/admin/project-permissions"
                    />
                    <AdministrationPanelRow />
                    <AdministrationPanelRow />
                    <AdministrationPanelRow />
                </AdministrationPanel>
            </Grid>
        </>
    );
}

export default Administration;